import React from 'react';
import { theme } from 'antd';
import { HolderOutlined } from '@ant-design/icons';

export default function SortableDragHandle({
  ariaLabel,
  disabled = false,
  iconSize = 11,
  className,
  onDragStart,
  onDragEnd,
}) {
  const { token } = theme.useToken();

  return (
    <span
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      className={className}
      draggable={!disabled}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        cursor: disabled ? 'not-allowed' : 'grab',
        color: token.colorTextDescription,
        padding: className ? '2px 4px' : '0 2px',
      }}
    >
      <HolderOutlined style={{ fontSize: iconSize }} />
    </span>
  );
}
